import { useEffect, useState } from 'react';

const useObjectUrl = file => {
  const [objectUrl, setObjectUrl] = useState('');

  useEffect(() => {
    if (!file) {
      setObjectUrl('');
      return undefined;
    }

    const url = URL.createObjectURL(file);
    setObjectUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [file]);

  return objectUrl;
};

export default useObjectUrl;
